import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EducationLoanComponent } from './education-loan.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: EducationLoanComponent,
    data: {
      title: "Education Loan",
      breadcrumb: "Education Loan"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class EducationLoanRoutingModule { }